import { DatePicker } from "antd";
import "antd/dist/reset.css";
import dayjs from "dayjs";
import { useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useGetMonthlyPaidInvoiceDataQuery } from "../../../../features/Dashboard/dashboard.api";
import colors from "../../../../theme/colors";

// ✅ Custom Tooltip Component
const CustomTooltip = ({ active, payload, label, year }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-theme-slate-800 text-white px-4 py-3 rounded-lg shadow-lg">
        <p className="font-semibold text-sm mb-1 text-white">
          {label} {year}
        </p>
        <p className="text-sm text-white">
          Total Payment (BDT):{" "}
          <span className="font-medium">
            {new Intl.NumberFormat("en-US").format(payload[0].value)}
          </span>
        </p>
      </div>
    );
  }
  return null;
};

const CustomCursor = (props: any) => {
  const { x, y, height, width } = props;
  const barWidth = 24;
  return (
    <rect
      x={x - barWidth / 2 + width / 2}
      y={y}
      width={barWidth}
      height={height}
      fill={colors.theme.primaryRest}
      rx={4}
    />
  );
};

const MonthlyPaymentsChart = () => {
  const [year, setYear] = useState("2025");

  const { data } = useGetMonthlyPaidInvoiceDataQuery({ params: { year } });

  return (
    <div className="p-4 rounded-lg border border-theme-indigo-50">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-medium">Monthly Payments</h2>

        <DatePicker
          allowClear={false}
          picker="year"
          className="w-28"
          placement="bottomRight"
          value={dayjs(year)} // controlled value
          onChange={(date) => setYear(date ? date.year().toString() : "")}
        />
      </div>

      <ResponsiveContainer width="100%" height={425}>
        <BarChart
          barSize={24}
          data={
            data?.data.chartData?.map((item) => ({
              month: item.x,
              payment: item.y,
            })) || []
          }
        >
          <defs>
            <linearGradient id="paymentGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#5246EE" stopOpacity={1} />
              <stop offset="100%" stopColor="#9189F4" stopOpacity={1} />
            </linearGradient>
          </defs>
          <XAxis
            tickFormatter={(value) => value.slice(0, 3)}
            dataKey="month"
            axisLine={false}
            tickLine={false}
          />
          <CartesianGrid strokeDasharray="4 4" />
          <YAxis
            tickFormatter={(value) => `${(value / 1000).toLocaleString()}k`}
            axisLine={false}
            tickLine={false}
          />
          {/* <Tooltip
            formatter={(value: number) =>
              new Intl.NumberFormat("en-US").format(value)
            }
          /> */}
          <Tooltip
            content={(props) => <CustomTooltip {...props} year={year} />}
            cursor={<CustomCursor />}
          />

          <Bar
            dataKey="payment"
            // fill={colors.theme.primary}
            fill={"url(#paymentGradient)"}
            radius={[8, 8, 8, 8]}
            width={24}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthlyPaymentsChart;
